// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"21a3b654","952":"b05c0afd"}[chunkId] + ".chunk.js";
};